
import FeaturedOnlineType from '@/components/FeaturedOnlineType.vue'
import PaneLineOnlineType from '@/components/panes/PaneLineOnlineType.vue'
import PaneTitle from '@/components/panes/PaneTitle.vue'
import { appStore, currentStore } from '@/store'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PaneFraction',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(appStore, ['isResale']),
    ...mapState(currentStore, ['fractionGroupsByBuilding']),
    fractionGroup() {
      const fractionGroups = this.isResale
        ? this.fractionGroupsByBuilding.resale
        : this.fractionGroupsByBuilding.all

      return fractionGroups.find((x) => x.hashID === this.id)
    },
    onlineTypes() {
      return this.fractionGroup?.oTypes ?? []
    },
    title() {
      return this.fractionGroup?.title ?? ''
    },
  },
  components: { PaneLineOnlineType, PaneTitle, FeaturedOnlineType },
  created() {
    // If no items - go back to root of current flow
    if (!this.onlineTypes.length) {
      this.$router.push({ name: this.$route.name as string })
    }
  },
})
